import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const certificateTemplateFields = {
  id: true,
  name: true,
  isDefault: true,
  title: true,
  body: true,
  signature: true,
  showScore: true,
  showDate: true,
  showTotalTime: true,
  emailOnUnlock: true,
  logo: true,
  orientation: true,
  hasSkeleton: true,
  marginTop: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
} as const

/** Ce qu'il faut d'un modèle pour le lister ou le choisir (#162). */
const templateOptionFields = { id: true, name: true, isDefault: true } as const

/** Les modèles de l'organisation, le défaut en tête (#162). */
export const GQL_CERTIFICATE_TEMPLATES = typedGql('query', { scalars })({
  certificateTemplates: templateOptionFields,
})

/** Les modèles choisissables dans un parcours, ouverts aux formateurs qui les gèrent (#162). */
export const GQL_CERTIFICATE_TEMPLATE_OPTIONS = typedGql('query', { scalars })({
  certificateTemplateOptions: templateOptionFields,
})

export const GQL_CERTIFICATE_TEMPLATE = typedGql('query', { scalars })({
  certificateTemplate: [{ id: $('id', 'ID') }, certificateTemplateFields],
})

export const GQL_UPDATE_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  updateCertificateTemplate: [
    { id: $('id', 'ID'), input: $('input', 'UpdateCertificateTemplateInput!') },
    certificateTemplateFields,
  ],
})

export const GQL_CREATE_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  createCertificateTemplate: [{ name: $('name', 'String!') }, templateOptionFields],
})

export const GQL_DUPLICATE_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  duplicateCertificateTemplate: [{ id: $('id', 'ID!'), name: $('name', 'String') }, templateOptionFields],
})

export const GQL_SET_DEFAULT_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  setDefaultCertificateTemplate: [{ id: $('id', 'ID!') }, templateOptionFields],
})

export const GQL_DELETE_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  deleteCertificateTemplate: [{ id: $('id', 'ID!') }, true],
})

export type CertificateTemplateOption = { id: string, name: string, isDefault: boolean }
